import React from 'react';
import { Helmet } from "react-helmet";
const AboutUs = () => {
    return (
        <div className="flex justify-center items-center mt-4 mb-1">
            <Helmet>
                <title>ABOUT US Tecom Hust Media</title>
            </Helmet>
            <div className="max-w-lg bg-white shadow-lg rounded-lg overflow-hidden">
                <div className="px-6 py-4">
                    <div className="font-bold text-xl mb-2">ABOUT US</div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Who We Are:</h2>
                        <p className="text-gray-700">We are a group from HUST University and Tecom Inc. With a passion for digital, we create products to make a profit and continue pursuing our passion.</p>
                    </div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Introducing Tecom company</h2>
                        <ul className="list-disc pl-6">
                            <li>Tecom is a company that manufactures broadcasting equipment. The company has 20 years of experience mastering both hardware and software technology.</li>
                            <li>Thousands of devices have been installed throughout the provinces and cities in the central region.</li>
                        </ul>
                    </div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Introducing Hust Media app</h2>
                        <ul className="list-disc pl-6">
                            <li>hust media is an e-commerce platform</li>
                            <li>With market research experience in my country is Vietnam. I realized that if there really was a commercially integrated application platform, it would be more user-friendly than just the available features. So the integration aims to make the project more attractive.</li>
                        </ul>
                    </div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Hust Media and Tecom cooperate together</h2>
                        <ul className="list-disc pl-6">
                            <li>Tecom is a hust media hardware company responsible for connecting devices to the company's customers</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
